import React, { useCallback, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import { renderToContainer } from '@/utils/render-to-container';
import { CnBox } from '../cn-box';
import { ImageViewerSlider } from './components/image-viewer-slider';
export function CnImageViewer(props) {
    const { src: _src, width, height } = props;
    const src = useMemo(() => {
        if (!_src)
            return [];
        if (typeof _src === 'string')
            return [_src];
        return _src;
    }, [_src]);
    const [index, setIndex] = useState(props.index || 0);
    const [visible, setVisible] = useState(false);
    const onClose = useCallback(() => {
        setVisible(false);
    }, []);
    const node = (React.createElement(ImageViewerSlider, { setIndex: setIndex, index: index, value: src, onTap: onClose }));
    return (React.createElement(React.Fragment, null,
        React.createElement(CnBox, { className: "cn-ui-m-image-viewer", wrap: true, direction: "row", spacing: 12 }, src.map((url, i) => (React.createElement("div", { key: url, className: "cn-ui-m-image-viewer-item", style: { backgroundImage: `url(${url})`, width, height }, onClick: () => {
                setIndex(i);
                setVisible(true);
            } })))),
        visible ? renderToContainer(document.body, node) : null));
}
CnImageViewer.displayName = 'CnImageViewer';
CnImageViewer.open = (props) => {
    const { index, src } = props;
    const getSrc = () => {
        if (!src)
            return [];
        if (typeof src === 'string')
            return [src];
        return src;
    };
    const container = document.createElement('div');
    document.body.appendChild(container);
    const hide = () => container.remove();
    ReactDOM.render(React.createElement(ImageViewerSlider, { index: index, value: getSrc(), onTap: hide }), container);
    return { hide };
};
